import { render, staticRenderFns } from "./PanelResumeReferences.vue?vue&type=template&id=41165dcf&"
import script from "./PanelResumeReferences.vue?vue&type=script&lang=js&"
export * from "./PanelResumeReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports